
import {Component, Vue, Watch} from 'vue-property-decorator';
import TopBar from '@/components/TopBar.vue';
import Background from '@/components/Background.vue';
import AppButton from '@/components/AppButton.vue';
import GateSurvey from '@/components/GateSurvey.vue';
import PreQuestionSurvey from '@/components/PreQuestionSurvey.vue';
import {MutationType, RouteName} from '@/enums';
import {Route} from "vue-router";
import PreQuestionField from '@/components/PreQuestionField.vue';
import OutroSurvey from "@/components/OutroSurvey.vue";
import BackButton from "@/components/BackButton.vue";
import {isVariationDiet, isVariationMunicipality} from "@/utils/common";
import UserInfoSurvey from "@/components/UserInfoSurvey.vue";

@Component({
		components: {
			UserInfoSurvey,
			BackButton,
			OutroSurvey,
			TopBar,
			Background,
			AppButton,
			GateSurvey,
			PreQuestionSurvey,
			PreQuestionField
		}
	})
	export default class Home extends Vue {
		private currentPage:String = RouteName.HOME;


		mounted() {
			this.currentPage = this.$router.currentRoute.meta.currentPage;
		}

		private get showIntro(): boolean {
			return this.currentPage === RouteName.HOME;
		}

		private get showUserInfoSurvey(): boolean {
			return this.currentPage === RouteName.USER_SURVEY;
		}

		private get showGateSurvey(): boolean {
			return this.currentPage === RouteName.GATE_SURVEY;
		}

		private get showOutro(): boolean {
			return this.currentPage === RouteName.OUTRO;
		}

		private get showPreQuestionSurvey(): boolean {
			return this.currentPage === RouteName.PRE_QUESTION_SURVEY;
		}

		private start(): void {
			if (isVariationDiet()) {
				this.goToPage(RouteName.USER_SURVEY)
			} else {
				this.goToPage(RouteName.PRE_QUESTION_SURVEY)
			}

		}

		private clickBackButton(): void {
			if (this.showUserInfoSurvey) {
				this.goToPage(RouteName.HOME);
			} else if (this.showGateSurvey) {
				this.goToPage(RouteName.HOME);
			} else if (this.showPreQuestionSurvey) {
				if (isVariationDiet()) {
					this.goToPage(RouteName.USER_SURVEY);
				} else {
					this.goToPage(RouteName.HOME);
				}
			} else if (this.showOutro) {
				this.goToPage(RouteName.OVERVIEW)
			}
		}

		private goToOverview(): void {
			this.goToPage(RouteName.OVERVIEW)
		}

		private goToPage(routeName: RouteName): void {
			this.$router.push({
				name: routeName
			});
		}

		private onUserSurveyFinish(): void {
			this.goToPage(RouteName.PRE_QUESTION_SURVEY)
		}

		private onInfoSurveyFinish(): void {
			this.goToPage(RouteName.RESULT)
		}

		private onGateSurveyFinish(): void {
			this.goToPage(RouteName.PRE_QUESTION_SURVEY)
		}

		@Watch('$route', { immediate: true, deep: true })
		onUrlChange(route:Route) {
			this.currentPage = route.meta.currentPage;
		}
	}
